import React, { Component } from "react";
import { Switch, Input, Checkbox, Button, message, Tooltip, Modal } from "antd";
import { getDomainSetting, postDomainSetting, checkPushUrl, getIsBindWeixin } from "@api/taobaoDomainChange";
import { getUser } from "@api/nav";
import { formatBooleanToNumber, formatNumberToBoolean } from "@/utils/format";
import { getQueryString } from "@/utils/tools";
import "./style.less";
const clsPrefix = "domainSetting";

class DomainSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDataChange: false,
      userId: "",

      isOpenThreshold: false,
      pv: null,
      uv: null,

      isPhoneSend: false,
      phone: null,
      isUrlSend: false,
      url: null,

      isSurplusNotice: false,
      isBindWeixin: false,
      subscribeVisible: false,

      domainCheck: false,
      flowCheck: false,
    };

    this.checkValidUrl = this.checkValidUrl.bind(this);
    this.getBindWeixinStatus = this.getBindWeixinStatus.bind(this);
    this.pollingBindWeixin = this.pollingBindWeixin.bind(this);
    this.timer = null;
  }

  async componentDidMount() {
    await getUser().then(res => {
      this.setState({ userId: res.data.user_id });
    });

    this.getBindWeixinStatus();

    getDomainSetting(this.state.userId).then(res => {
      const {
        isOpenThreshold,
        pv,
        uv,
        isPhoneSend,
        phone,
        isUrlSend,
        url,
        domainCheck,
        flowCheck,
        isSurplusNotice,
      } = res;
      this.setState({
        isOpenThreshold: formatNumberToBoolean(isOpenThreshold),
        pv,
        uv,
        isPhoneSend,
        phone,
        isUrlSend,
        url,
        domainCheck,
        flowCheck,
        isSurplusNotice: formatNumberToBoolean(isSurplusNotice),
      });
    });
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  convertPostData() {
    const { userId } = this.state;
    const {
      isOpenThreshold,
      isPhoneSend,
      isUrlSend,
      domainCheck,
      flowCheck,
      isSurplusNotice,
    } = this.state;
    if (!this.checkPhone()) {
      message.error("电话格式不正确，请重新填写！");
      return;
    }

    if (!this.checkUrl()) {
      message.error("接口地址格式不正确，请重新填写！");
      return;
    }
    let data = Object.assign(
      {},
      {
        ...this.state,
        isOpenThreshold: formatBooleanToNumber(isOpenThreshold),
        isPhoneSend: formatBooleanToNumber(isPhoneSend),
        isUrlSend: formatBooleanToNumber(isUrlSend),
        domainCheck: formatBooleanToNumber(domainCheck),
        flowCheck: formatBooleanToNumber(flowCheck),
        isSurplusNotice: formatBooleanToNumber(isSurplusNotice),
      },
      { userId }
    );
    delete data.hasDataChange;
    return data;
  }
  async handleSwitch(item, isOpen) {
    let initItem = this.state[item];
    if (initItem !== isOpen) {
      this.setState({ hasDataChange: true });
    }
    await this.setState({
      [item]: isOpen
    });
  }

  checkPhone() {
    const { phone, isPhoneSend } = this.state;
    let phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
    if (isPhoneSend && !phoneReg.test(phone)) {
      return false;
    } else if (!isPhoneSend && (phone && !phoneReg.test(phone))) {
      return false;
    } else {
      return true;
    }
  }

  checkUrl() {
    const { isUrlSend, url } = this.state;
    let urlReg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    if (isUrlSend && !urlReg.test(url)) {
      return false;
    } else if (!isUrlSend && (url && !urlReg.test(url))) {
      return false;
    } 
    return true;
  }

  handleChange(item, e) {
    let initData = this.state[item];
    let newData =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (initData !== newData) {
      this.setState({
        hasDataChange: true
      });
    }
    this.setState({
      [item]: e.target.type === "checkbox" ? e.target.checked : e.target.value
    });
  }

  handleSubmit() {
    let postData = this.convertPostData();
    const { userId } = this.state;
    postData &&
      postDomainSetting(userId, postData)
        .then(() => {
          message.success("设置成功");
        })
        .catch(() => {
          message.error("设置失败");
        });
  }
  handleCancel() {
    window.location.href = `/v5/tkPlugin?site_id=${getQueryString("site_id")}`;
  }

  checkValidUrl() {
    const { url } = this.state;
    if (!url) {
      return
    }
    checkPushUrl(url).then(() => {
      message.success('测试成功')
    }).catch((error) => {
      if (error.code === 50003) {
        message.error(error.msg);
        this.setState({
          url: ''
        })
      }
    })
  }

  getBindWeixinStatus() {
    // 调接口
    getIsBindWeixin().then(data => {
      this.setState({
        isBindWeixin: data && data.isSubscribe,
      })
    });
  }

  pollingBindWeixin() {
    this.timer = setInterval(() => {
      console.log(this.timer, 'set timer');
      getIsBindWeixin().then(res => {
        if (res.isSubscribe) {
          clearInterval(this.timer);
          this.getBindWeixinStatus();
        }
        console.log(this.timer, 'after clear')
      })
    }, 2000)
  }

  render() {
    const {
      hasDataChange,
      isOpenThreshold,
      pv,
      uv,
      isPhoneSend,
      phone,
      isUrlSend,
      url,
      domainCheck,
      flowCheck,
      isSurplusNotice,
      isBindWeixin,
      subscribeVisible,
    } = this.state;
    return (
      <div>
        <div className={clsPrefix}>
          <div className={`${clsPrefix}__domainSetting commonStyle`}>
            <div className={`${clsPrefix}__domainSetting--left`}>
              <p className='titleStyle'>域名阈值设置</p>
              <p className='infoCommonStyle'>设置阈值，超过阈值可触发报警</p>
              <div className={`${clsPrefix}__domainSetting--left--threshold`}>
                <div className='inlineStyle'>
                  <span>日UV上限: &nbsp;</span>
                  <div>
                    <Input
                      type='number'
                      value={uv}
                      onChange={e => {
                        this.handleChange("uv", e);
                      }}
                    />
                  </div>
                </div>
                <div className='inlineStyle'>
                  <span>日PV上限: &nbsp;</span>
                  <div>
                    <Input
                      value={pv}
                      type='number'
                      onChange={e => {
                        this.handleChange("pv", e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={`${clsPrefix}__domainSetting--rightSwitch`}>
              <Switch
                checked={isOpenThreshold}
                onChange={value => {
                  this.handleSwitch("isOpenThreshold", value);
                }}
              />
            </div>
          </div>
          <div className={`${clsPrefix}__message commonStyle`}>
            <div className={`${clsPrefix}__message--left`}>
              <p className='titleStyle'>消息推送</p>
              <p className='infoCommonStyle'>在域名变更时为用户推送通知</p>
              <div className={`${clsPrefix}__message--left--message`}>
                <div className='inlineStyle'>
                  <Checkbox
                    checked={isPhoneSend}
                    onChange={e => {
                      this.handleChange("isPhoneSend", e);
                    }}
                  >短信推送</Checkbox>
                  <div>
                    <Input
                      style={{ width: "208px", marginLeft: '6px' }}
                      value={phone}
                      required={isPhoneSend ? "required" : false}
                      onBlur={() => {
                        this.checkPhone();
                      }}
                      onChange={e => {
                        this.handleChange("phone", e);
                      }}
                    />
                    <span style={{ color: "#ccc", marginLeft: 10 }}>
                      请填写11位的有效手机号
                    </span>
                  </div>
                </div>
                <div className='inlineStyle'>
                  <Checkbox
                    checked={isUrlSend}
                    onChange={e => {
                      this.handleChange("isUrlSend", e);
                    }}
                  >接口推送</Checkbox>
                  <div className='inlineStyle' style={{ marginTop: 0 }}>
                    <Input
                      value={url}
                      style={{ width: "294px", marginLeft: '6px' }}
                      onBlur={e => this.checkUrl(e)}
                      onChange={e => {
                        this.handleChange("url", e);
                      }}
                    />
                    <Tooltip title="点击后，系统将会发一条测试数据供您调试，请慎点">
                      <Button type="primary" ghost onClick={this.checkValidUrl}>点我测试</Button>
                    </Tooltip>  
                    <span style={{ color: "#ccc", marginLeft: 10 }}>
                      接口推送格式是http:// 或https://
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${clsPrefix}__surplus-notice`}>
              <p className='infoCommonStyle'>自动域名次数不足预警提醒推送通知</p>
              <div className='inlineStyle' style={{ alignItems: 'baseline' }}>
                <Checkbox
                  checked={isSurplusNotice}
                  onChange={e => {
                    this.handleChange("isSurplusNotice", e);
                  }}
                >
                  微信推送
                </Checkbox>
                {
                  !isBindWeixin ? (
                    <div className={`${clsPrefix}__warn`}>
                      注意：您未绑定微信号或微信号未关注“快站”公众号，无法接收到预警提醒 
                      <span
                        style={{ color: '#68aeff', cursor: 'pointer', marginLeft: '8px' }}
                        onClick={() => {
                          this.setState({
                            subscribeVisible: true, 
                          })
                          this.pollingBindWeixin();
                        }}
                      >立即设置&gt;&gt;</span>
                    </div>
                  ) : null
                }
              </div>
              <Modal
                title='提示'
                visible={subscribeVisible}
                onCancel={() => {
                    if (this.timer) {
                        clearInterval(this.timer);
                    }
                    this.setState({ subscribeVisible: false })
                }}
                onOk={() => this.setState({ subscribeVisible: false })}
              >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <img
                    src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQF77zwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyREVoVnhUamxkMm0xdnlEYWh4MXgAAgTiWiNhAwQAjScA"
                    alt="微信公众号二维码"
                    style={{ width: '160px', height: '160px' }}
                  />
                  <span>扫描二维码并关注快站公众号自动完成绑定操作</span>
                </div>
              </Modal>
            </div>
          </div>
          <div className={`${clsPrefix}__domainChange commonStyle`}>
            <div className={`${clsPrefix}__domainChange--left`}>
              <p className='titleStyle'>域名智能切换</p>
              <p className='infoCommonStyle'>智能切换站点域名，保留用户流量</p>
              <div className='inlineStyle'>
                <Checkbox
                  checked={domainCheck}
                  onChange={e => {
                    this.handleChange("domainCheck", e);
                  }}
                />
                <span style={{ marginLeft: '4px' }}>域名异常时切换</span>
              </div>
              <div className='inlineStyle'>
                <Checkbox
                  checked={flowCheck}
                  onChange={e => {
                    this.handleChange("flowCheck", e);
                  }}
                />
                <span style={{ marginLeft: '4px' }}>流量超标时切换</span>
              </div>
            </div>
          </div>
        </div>
        {hasDataChange && (
          <div className={`${clsPrefix}__submit`}>
            <Button
              type='primary'
              onClick={() => {
                this.handleSubmit();
              }}
            >
              确认
            </Button>
            <Button
              style={{ marginRight: 24, marginLeft: 8 }}
              onClick={() => {
                this.handleCancel();
              }}
            >
              取消
            </Button>
          </div>
        )}
      </div>
    );
  }
}
export default DomainSetting;
